import { Observable } from 'rxjs';
import { BaseInput, BaseInputConstructor } from './base-input';

interface LabelValue<T, E> {
    label: T;
    value: E;
}

export type MultiSelectOption<T = string, E = string> = LabelValue<T, E>;

export interface MultiSelectInputConstructor<T, E> extends BaseInputConstructor<T> {
    options: Observable<MultiSelectOption<T, E>[]>;
}

export class MultiSelectInput<T = string, E = string> extends BaseInput<T> {
    override inputType = 'multi-select';
    override readonly __internalConstructor__: MultiSelectInputConstructor<T, E>;
    options: Observable<MultiSelectOption<T, E>[] | null>;

    constructor(options: MultiSelectInputConstructor<T, E>) {
        super(options);
        this.__internalConstructor__ = options;
        this.options = options.options;
    }

    clone(): MultiSelectInput<T, E> {
        return new MultiSelectInput(this.__internalConstructor__);
    }
}
